import { NomenclaturesValuesEnum } from '../utils/enums'
import { axios, getConfigs } from './api'
import { IRequestConfig } from './api'
import {
  CreateDMPSubmissionDTO,
  DmpSubmissionDetailsDTO,
  DmpSubmissionDTO,
  NomenclatureDTO,
} from './dtos/dmp.dto'

export class DmpService {
  private static readonly endpoint = 'dmp'
  private static readonly devboxEndpoint = process.env.REACT_APP_DEVBOX_URL

  static getDmpByOrders(orderIds: number[]): Promise<DmpSubmissionDTO[]> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        `${this.endpoint}`,
        {},
      )
      configs.params = {
        orderIds,
      }

      axios(configs, resolve, reject)
    })
  }

  static getDmpSubmissionDetails(id: string): Promise<DmpSubmissionDetailsDTO> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        `${this.endpoint}/${id}`,
        {},
      )

      axios(configs, resolve, reject)
    })
  }

  static createDmpSubmission(
    dmpSubmission: CreateDMPSubmissionDTO,
  ): Promise<DmpSubmissionDetailsDTO> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        `${this.endpoint}`,
        {},
      )
      configs.data = dmpSubmission

      axios(configs, resolve, reject)
    })
  }

  static async getNomenclatures(
    jeuxValeurs: NomenclaturesValuesEnum,
  ): Promise<NomenclatureDTO[]> {
    const res = await fetch(
      `${process.env.REACT_APP_API_URL}/devbox/dmp/nomenclatures?jeuxValeurs=${jeuxValeurs}`,
    )
    const data = await res.json()
    return data
  }
}
